import React from 'react';

import {ReceiveCashRefundForm} from './components';
import './styles.css';

const ReceiveCashRefund = ({
  refetchExtraActions,
  tenancyId,
  scheduleType,
  overpaymentId,
  getExtraActions,
  storeDataExtraActions,
  locationRef
}) => {
  return (
    <div className="ReceiveCashRefund">
      <div className="horizontalLine" />
      <div className="header">Make a cash refund</div>
      <ReceiveCashRefundForm
        refetchExtraActions={refetchExtraActions}
        tenancyId={tenancyId}
        scheduleType={scheduleType}
        overpaymentId={overpaymentId}
        getExtraActions={getExtraActions}
        storeDataExtraActions={storeDataExtraActions}
        locationRef={locationRef}
      />
      <div className="horizontalLine" />
    </div>
  );
};

export default ReceiveCashRefund;
